<template><div>

	<div class="leftmenu catalog" v-if="catalog">
		
		<div class="welcome-text">
			<h2 class="h2">Hi, {{catalog.client}}</h2>
			We have prepared a select list of models that you can request quickly and easily.<br><br>
			After selecting your desired models from the categories below you can send your request.<br><br>
			We will respond back to you as soon as possible.
		</div>

		<b v-if="active_catalog_category">
			<div class="active-cat-title" @click="gotoCat(undefined)">
				Back to categories
			</div>
			<br><br>
		</b>

		<b><a href="mailto:booking@scoopmodels.com?subject=Regarding%20my%20catalog">Contact</a></b>
		
	</div>

	<div class="view">

		<main>

			<div class="catalog" v-if="catalog">


				<div class="titler" v-if="false">
					<span>{{catalog.client}}</span> <span>x</span>
				</div>


				<div class="welcome-text" v-if="false">
					<b>Welcome to your catalog</b><br>
					&mdash; We have prepared a select list of models that you can request quickly and easily.<br>
					&mdash; After selecting your desired models from the categories below you can send your request.<br>
					&mdash; We will respond back to you as soon as possible.
				</div>


				<div class="catalog-notes" v-if="catalog.notes && !active_catalog_category">
					<b>Notes</b>
					<div v-html="catalog.notes"></div>
				</div>
				
				<div v-if="active_catalog_category" class="cat-title-back-btn" @click="gotoCat(undefined)">Back</div>
				<h2 class="h2 active-cat-title-27" v-if="active_catalog_category">{{active_catalog_category.title}}</h2>

				<div class="catalog-notes" v-if="active_catalog_category && active_catalog_category.notes">
					<b v-if="0">Category '{{active_catalog_category.title}}' notes</b>
					<div v-html="active_catalog_category.notes"></div>
				</div>


				<div class="subtitle-line" v-if="0">

					<br><br>

					<div class="active-cat-title" v-if="active_catalog_category" @click="gotoCat(undefined)">
						Category: {{active_catalog_category.title}}
					</div>

					<template v-if="0 && active_catalog_category">/</template>
					
					<div class="cat-back-btn" v-if="0 && active_catalog_category" @click="gotoCat(undefined)">
						Back
					</div>				
					
				</div>


				<div class="category-btns" v-if="!active_catalog_category">
					<div class="category-btn"
						v-for="(cat,cat_i) in catalog.content.categories"
						:key="'asdas'+cat_i"
						@click="gotoCat(cat_i)"
					>
						<span>Category</span><br>
						{{cat.title}}

						<template v-if="loggedin_user">
							<div class="admin-rename-btn" @click.stop="adminRenameCategory(cat)">Rename</div>
							<div class="admin-notes-btn" @click.stop="adminUpdateNotesCategory(cat)">Notes</div>
							<div class="admin-delete-btn" @click.stop="adminDeleteCategory(cat_i)">Delete</div>
							<template v-if="catalog.content.categories.length > 1">
								<div class="admin-move-prev-btn" @click.stop="adminMoveCategory(cat_i,-1)" v-if="cat_i > 0">Move up</div>
								<div class="admin-move-next-btn" @click.stop="adminMoveCategory(cat_i,1)" v-if="cat_i+1 < catalog.content.categories.length">Move down</div>
							</template>
						</template>

					</div>				
				</div>

				<template v-if="catalog && loggedin_user && !active_catalog_category">
					<div class="btn btn-white shadowed" @click="adminAddCategory()">Add category...</div>
				</template>

				<div v-if="active_catalog_category && !active_catalog_category_items.length && !loggedin_user">
					This category is empty.
				</div>

				<casting-items-list
					v-if="!loggedin_user && active_catalog_category_items"
					:itemgroups="active_catalog_category_items_grouped"
					:can-remove-items="false"
					:can-add-items="false"
					:can-select-items="false"
					:can-select-itemgroups="true"
					:empty-text="' '"
					showItemGroupRates="true"
					no-hires-passgate
					itemGroupActionBtnLabel="Select"
					@itemSelectionChanged="itemSelectionChanged"
					@itemGroupSelectionChanged="itemGroupSelectionChanged"
				/>


				<casting-items-list
					v-if="loggedin_user && active_catalog_category_items"
					:itemgroups="active_catalog_category_items_grouped"
					:can-remove-items="true"
					can-add-items="false"
					:empty-text="' '"
					no-hires-passgate
					itemGroupActionBtnLabel="Remove"
					showItemGroupRates="true"
					canEditRates="true"
					@removeItem="removeItem"
					@removeItemGroup="removeItemGroup"
					@addItem="addItem"
					@editRate="editRate"
				/>

				
				<div class="request-section" v-if="selectedItems_length && !loggedin_user">

					<h2 class="h2">Your request</h2>

					<div class="request-summary">

						<div class="catalog-notes" v-if="catalog.notes" v-html="'<b>Notes</b>'+catalog.notes"></div>

						<div class="cat" v-for="(cat,cat_i) in selectedItems" :key="'dsad'+cat_i">
							
							<div class="cat-title-32">{{cat.title}}</div>

							<div class="cat-notes" v-if="cat.notes" v-html="cat.notes"></div>

							<div class="items">
								<div class="item" v-for="(item,item_i) in cat.items" :key="'dvdsad'+item_i">
									
									<img :src="base_url+'media/'+item.media.id+'/80'" alt="" width="100px" height="auto" class="img" alt="" />

									<span class="text">
										<span class="name">{{item.model.full_name}}</span><br>
										<span class="rate">{{item.rate||'Unknown rate'}}</span>
									</span>
								</div>
							</div>

						</div>
					</div>

					<div class="cols cols-2">

						<div class="field" v-if="0">
							<label>Booker</label>
							<select v-model="selected_staff_index">
								<option :value="undefined">Select...</option>
								<option v-for="(staff,staff_i) in stafflist" :value="staff_i" :key="'dsad'+staff_i">{{staff.first_name}} {{staff.last_name}}</option>
							</select>
							<div class="select-arrow">&#9662;</div>
						</div>
					
						<div class="field">
							<label>Date</label>
							<input type="text" v-model="request_date">
						</div>
						
						<div class="field">
							<label>Location</label>
							<input type="text" v-model="request_location">
						</div>
						
						<div class="field">
							<label>Number of shoot days</label>
							<input type="text" v-model="request_shootdays">
						</div>
						
						<div class="field">
							<label>Photographer</label>
							<input type="text" v-model="request_photographer">
						</div>
						
						<div class="field">
							<label>Stylist</label>
							<input type="text" v-model="request_stylist">
						</div>
						
						<div class="field">
							<label>Hair/makeup</label>
							<input type="text" v-model="request_hairmakeup">
						</div>
						
						<div class="field">
							<label>My email</label>
							<input type="text" v-model="request_clientemail">
						</div>
						
						<div class="field">
							<label>Notes</label>
							<input type="text" v-model="request_notes">
						</div>

					</div>

					<div class="req-notifier">
						<b>Important</b><br>
						If you have any specific needs or details, please make sure they are written in the notes field above. Also, please make sure you have read through the details of your request, so we can make sure we can handle your request as quickly and efficiently as possible.<br>
						This is just a request and not a confirmation.
					</div>
					
					<div class="btn btn-black" @click="sendRequest()">Send request</div>

				</div>

			</div>


			<div v-if="loggedin_user">
				<br><br>
				<div class="btn btn-white shadowed" v-if="active_catalog_category" @click="addItem()">Add...</div>
			</div>


			<div v-if="loggedin_user">
				<br><br>
				<div class="btn btn-white shadowed" v-if="catalog" @click="onEditSettingsBtnClick()">Edit settings</div> &nbsp; 
				<div class="btn btn-black" v-if="catalog" @click="adminSaveCatalogChanges()">Save</div>
			</div>


			<div v-if="error" class="">
				<br><br>
				<h1 class="h1">Not found</h1>
				<p v-if="error == 'missing-input'">We couldn't find what you were looking for, please make sure the URL and passphrase are correct.</p>
				<p v-if="error == 'no-catalog-found'">We couldn't find what you were looking for, please make sure the URL and passphrase are correct.</p>
				<p v-else>We couldn't find what you were looking for.</p>
				<box v-if="is_milk" label="Milk/dev debug error"><pre>{{error}}</pre></box>
				<br><br>
			</div>

			<template v-if="0 && is_milk">
				<br><br><br>
				<div class="box">
					<div class="box-header">Milk / Dev</div>
					<div class="box-content">
						<pre>{{catalog}}</pre>
					</div>
				</div>
			</template>
						
		</main>
	
	</div>

	<div class="package-minimenu" :class="{lookatme:minicart_focused}" @click="minicartClick()" v-if="!loggedin_user && catalog">
      <span class="text1">{{selectedItems_length}} models selected</span>
      <span class="text2">{{selectedItems_length}} models selected</span>
    </div>

</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import axios from 'axios'; import qs from 'qs'
import CastingItemsList from '.././components/CastingItemsList'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		CastingItemsList,
	},

	data(){ return {
		
		error: undefined,
		
		active_cat_i: undefined,

		stafflist: undefined,
		selected_staff_index: undefined,

		request_date: undefined,
		request_location: undefined,
		request_notes: undefined,
		request_stylist: undefined,
		request_photographer: undefined,
		request_hairmakeup: undefined,
		request_clientemail: undefined,
		request_shootdays: undefined,

		admin_unsaved_changed: false,

		minicart_focused: false,

	}},

	computed: {

		catalog(){ return this.$store.state.loaded_catalog },
		
		slug(){ return this.route.params.slug },

		active_catalog_category(){
			if( this.active_cat_i === undefined ) return
			if( !this.catalog ) return
			if( !this.catalog.content.categories ) return
			return this.catalog.content.categories[this.active_cat_i]
		},

		active_catalog_category_items(){
			if(!this.active_catalog_category) return
			return this.active_catalog_category.items
		},


		active_catalog_category_items_grouped(){
			
			if( !this.active_catalog_category_items ) return []
			var items = JSON.parse(JSON.stringify(this.active_catalog_category_items))
			var groups = helpers.casting_items_groupify(items)

			// copy rate and selected over from first item to group. values are the same for all items in the group anyways
			for( let group of groups ) {
				if( group.items[0] ) {
					group.rate = group.items[0].rate
					group._is_selected = group.items[0]._is_selected
				}
			}

			return groups

		},


		selectedItems(){
						
			if( !this.catalog ) return
			if( !this.catalog.content.categories ) return
			var cats = JSON.parse(JSON.stringify(this.catalog.content.categories))
			
			// remove duplicate model_id items
			for( let cat of cats ) {
				let model_ids_processed = []
				cat.items = cat.items.filter((item)=>{
					if( model_ids_processed.indexOf(item.model_id) !== -1 ) return false
					if( !item._is_selected ) return false
					model_ids_processed.push(item.model_id)
					return true
				})
			}

			// remove empty cats
			cats = cats.filter((cat)=>{ return cat.items.length })

			console.log(cats)
			return cats

		},


		selectedItems_length(){
			var c = 0
			if( !this.selectedItems || !this.selectedItems.length ) return c
			for( let cat of this.selectedItems ) for( let item of cat.items ) c++
			return c
		},

		selectedStaffMember(){
			if( !this.stafflist ) return
			return this.stafflist[this.selected_staff_index]
		},

	},

	methods: {


		passphrase_mangle(str){ return helpers.passphrase_mangle(str) },
		

		gotoCat(cat_i){
			this.active_cat_i = cat_i
		},

		apply_items_selectionables(){			
			for( let category of this.catalog.content.categories ) {
				for( let item of category.items ) {					
					this.$set( item, '_is_selected', false )
				}	
			}
		},

		strip_items_selectionables(catalog){
			var catalog = { ...catalog }
			for( let category of catalog.content.categories ) {
				for( let item of category.items ) {					
					delete item._is_selected
				}	
			}
			return catalog
		},


		adminAddCategory(){
			var title = prompt('Category title')
			var cat = {
				title:title,
				notes:undefined,
				items: [],
			}
			this.catalog.content.categories.push(cat)
			this.admin_unsaved_changed = true
		},


		adminRenameCategory(cat) {
			var title = prompt('Title')
			if( !title ) return
			cat.title = title
			this.admin_unsaved_changed = true
		},

		adminDeleteCategory(cat_i) {
			var sure = prompt('Type DELETE if you ware sure you want to delete')
			if( !sure || sure.toLowerCase() !== 'delete' ) return
			this.catalog.content.categories.splice(cat_i,1)
		},

		adminMoveCategory(cat_i,indexOffset) {
			
			var from = cat_i
			var to = cat_i + indexOffset

			if( to < 0 ) to = 0
			if( to >= this.catalog.content.categories.length ) return

			this.catalog.content.categories.splice(to, 0, this.catalog.content.categories.splice(from, 1)[0])
			this.admin_unsaved_changed = true
		},


		onEditSettingsBtnClick(){
			if( this.admin_unsaved_changed ) {
				var sure = confirm('You have unsaved changes. Continue without saving?')
				if( !sure ) return
			}
			this.goto( '/admin/catalog/'+this.catalog.id )
		},

		adminUpdateNotesCategory(cat){
			this.set_generic_field_editor({
				active: true,
				field_type: 'text',
				label: 'Category notes',
				value: cat.notes,
				placeholder: 'Usage rights, special conditions, etc.',
				onSave: (value) => {
					cat.notes = value
					this.set_generic_field_editor({active:false})
					this.toast('Category notes updated, remember to save')
				},
			})
		},


		adminSaveCatalogChanges(){
			var content = JSON.parse(JSON.stringify(this.catalog.content))
			var input = {
				access_token: this.$store.state.loggedin_user.access_token,
				item_id: this.catalog.id,
				content_json: JSON.stringify(content),
			}

			var _this = this

			this.spinner(true)

			return axios.post( this.$store.state.api_url + 'admin_update_catalog', qs.stringify(input) )
				.then(function(result){
					var output = result.data
					if( !_this.validateApiOutput(output) ) return
					if( output.error ) { console.log('error',output.error); return }

					_this.triggerIconSignal('check')
					_this.spinner(false)
					_this.toast('Catalog saved')
					_this.admin_unsaved_changed = false
				})
				.catch(function(error){					
					_this.msg('Error: Could not save, please try again or contact support...')
					_this.spinner(false)
					console.log('error',error)
				})

		},


		load_staff(){
			var _this = this
			this.fetch( 'get_scoop_staff', {}, 
			{ onSuccess: function(output){
				
				if( !output.status || output.status !== 'success' ) {
					_this.msg('Error: Could not find staff contact list, please contact us by email instead...')
					return
				}				
				_this.stafflist = output.data

			}, onError: function(output){
				_this.msg('Error: Could not find staff contact list, please contact us by email instead...')
				return
			}})
		},


		load_catalog( slug, passphrase ){
			if( !slug || !slug.length ) return
			
			var input = {				
				slug:slug,
				passphrase:passphrase,
			}

			if( this.loggedin_user ) input.access_token = this.$store.state.loggedin_user.access_token

			var _this = this
			this.fetch( 'get_catalog', input, 
			{ onSuccess: function(output){
				
				if( !output.status || output.status !== 'success' ) {
					_this.error = output
					return
				}
				
				//_this.catalog = output.catalog
				_this.$store.commit('set_loaded_catalog', output.catalog)
				_this.apply_items_selectionables()
				_this.$store.commit('set__logo_pre_html', '<span>'+output.catalog.client+'</span> x')

			}, onError: function(output){
				_this.error = output
			}})
		},


		items_refresh_metadata(){
			var items = this.catalog.content.categories[this.active_cat_i].items
			this.$store.dispatch('casting_items_load_metadata', items)
				.then((items)=>{
					var catalog = JSON.parse(JSON.stringify(this.catalog))
					catalog.content.categories[this.active_cat_i].items = items
					this.$store.commit('set_loaded_catalog', catalog)
				})
		},
				

		sendRequest(){

			var input = {
				catalog: JSON.parse(JSON.stringify(this.catalog)),
				location: this.request_location,
				photographer: this.request_photographer,
				stylist: this.request_stylist,
				hairmakeup: this.request_hairmakeup,
				date: this.request_date,
				shootdays: this.request_shootdays,
				clientemail: this.request_clientemail,
				//contactperson: this.selectedStaffMember,
				notes: this.request_notes,
			}	

			// validate

			if( !input.clientemail || !helpers.validateEmail(input.clientemail) ) { this.toast('Please type a valid email'); return }			

			input.catalog.content.categories = JSON.parse(JSON.stringify(this.selectedItems))
			
			this.big_spinner(1)

			var _this = this
			this.fetch( 'send_catalog_request', input, 
			{ onSuccess: function(output){
				
				_this.big_spinner(0)

				if( !output.status || output.status !== 'success' ) {
					_this.error = output.error
					_this.alert('Error, please try again...')
					return
				}
				
				_this.msg('Thank you. We will respond as quickly as possible.')

				_this.active_cat_i = undefined

			}, onError: function(output){
				_this.toast('Error, please try again...')
				_this.big_spinner(0)
			}})

		},

		removeItem(e) {
			var sure = confirm('Are you sure?')
			if(!sure) return
			var entry_i = e.item_i
			this.catalog.content.categories[this.active_cat_i].items.splice( entry_i,1 )
			//this.toast('Item removed')
		},
		

		removeItemGroup(e){
			var sure = confirm('Are you sure?')
			if(!sure) return
			var items = this.catalog.content.categories[this.active_cat_i].items.filter((item)=>{
				return item[e.type] !== e.id
			})			
			this.$set( this.catalog.content.categories[this.active_cat_i], 'items', items )
		},

		itemSelectionChanged(e){
			var entry_i = e.item_i
			this.catalog.content.categories[this.active_cat_i].items[entry_i]._is_selected = !this.catalog.content.categories[this.active_cat_i].items[entry_i]._is_selected			
		},
		
		itemGroupSelectionChanged(itemgroup){
			for( let item of this.catalog.content.categories[this.active_cat_i].items ) {
				if( itemgroup.model_id && item.model_id == itemgroup.model_id ) this.$set(item,'_is_selected', !item._is_selected )
			}
			this.$store.commit('set_loaded_catalog', this.catalog)
			//this.toast('Selection updated')			


			this.minicart_focused = true
			setTimeout(()=>{ this.minicart_focused = false },250)

		},

		itemActionButtonOnClick(e){
			alert('item action button clicked')
		},

		editRate(input){
			var oldvalue = undefined

			for( let item of this.active_catalog_category_items ) {
				if( input.itemgroup.model_id && item.model_id == input.itemgroup.model_id ) oldvalue = item.rate
			}

			this.set_generic_field_editor({
				active: true,
				field_type: 'text',
				label: 'Rate',
				value: oldvalue,
				placeholder: undefined,
				onSave: (value) => {
					
					this.set_generic_field_editor({active:false})
					
					this.$set( input.itemgroup, 'rate' , value)

					for( let item of this.catalog.content.categories[this.active_cat_i].items ) {
						if( input.itemgroup.model_id && item.model_id == input.itemgroup.model_id ) this.$set(item,'rate',value)
					}
					this.$store.commit('set_loaded_catalog', this.catalog)

				},
			})

		},


		addItem(e) {
			//var entry_i = e.item_i
			
			var _this = this

			this.$store.commit('set_admin_medialib_on_media_select', function(items){

				for( let item of items ) {

					let item2 = {
						media_id: item.id,
						model_id: _this.$store.getters.medialib_active_folder_model_id,
						rate: undefined,
						_is_selected: false,
					}

					_this.catalog.content.categories[_this.active_cat_i].items.push(item2)
					
				}

				_this.items_refresh_metadata()

			})

			this.medialib_visibles({ models_media:1, artists_media:0, influencers_media:0, other_media:0, contentpages:0, newsarticles:0, artistgalleries:0, })
			this.medialib_open({})

		},


		save(){
			var catalog = this.catalog
			catalog = this.strip_items_selectionables(catalog)

			console.log(catalog)
		},

		minicartClick(){
			
			var el = document.querySelector('.request-section')
			if( !el ) return
			var top = el.offsetTop
			var wh = window.innerHeight
			var scrollY = window.scrollY
			helpers.scrollTo2(top, 600)			

		},
	

	},

	watch: {

		

	},


	created(){
	
		if( !this.loggedin_user ) {			
			var passphrase = prompt('Password')
			var passphrase_input_valid = ( passphrase && passphrase.length )
			if( !passphrase_input_valid ) window.location.reload()
			var passphrase_mangled = this.passphrase_mangle(passphrase)
		}

		this.load_catalog( this.slug, passphrase_mangled )

		//this.load_staff()

	},

	mounted(){
		//document.querySelector('#header-logo').classList.add('joe')
		window.$el = this
		
	},

	destroyed(){
		//document.querySelector('#header-logo').classList.remove('joe')
		this.$store.commit('set__logo_pre_html', undefined)

	},

}
</script>



// WEBPACK FOOTER //
// src/views/Catalog.vue